import * as React from 'react';

import ServerPageProvider from '@common/react/components/Core/ServerPageProvider/ServerPageProvider';
import ImageLazy from '@common/react/components/UI/ImageLazy/ImageLazy';

import { Doctor } from '@commonTuna/react/objects/BaseDoctor';
import { NTBaseItemsPage } from '@commonTuna/react/objects/Page';

import FooterInquiryForm from '@app/components/UI/Footer/FooterInquiry';

import '@app/scss/pages/about.scss';

const About: React.FC = () => {
	return (<ServerPageProvider<NTBaseItemsPage<Doctor>>
		path="about"
		inner={({ items: { list } }) => (
			<div className="about-page">
				<div className="container">
					<div className="inner-page__headline text-center">
						<h1>About Us</h1>
					</div>
					<div>
						<div className="about-text">
							{list.length > 0
								&& <>
									<h3>{list[0].nameEn}</h3>
									{list[0].professions.length > 0
										&& <p>
											<strong>
												{list[0].professions[0].profession.nameEn}
											</strong>
										</p>
									}
									<p
										className="external-html"
										dangerouslySetInnerHTML={{ __html: list[0].descriptionEn }}
									/>
									<div className="images-block">
										{list[0].images.map(({ id, file: { src } }, index) => (
											<img
												alt={`${list[0].nameEn}-${index}`}
												key={id}
												style={{ flexBasis: 351 }}
												src={`/remote/${src}`}
												width="351"
												height="525"
											/>
										))}
									</div>
								</>
							}
						</div>
					</div>
					<div className="inner-page__headline text-center">
						<h1>Meet The Staff</h1>
					</div>
					{list.slice(1).map(({
						id,
						nameEn,
						descriptionEn,
						originalAvatar,
						professions,
					}) => <div className="about-content-block" key={id}>
						<ImageLazy
							alt={nameEn}
							src={`/remote/${originalAvatar}`}
							width="40%"
						/>
						<div className="about-text">
							<h3>{nameEn}</h3>
							<p>
								<strong>
									{professions.length > 0
										&& professions[0].profession.nameEn
									}
								</strong>
							</p>
							<p className="external-html" dangerouslySetInnerHTML={{ __html: descriptionEn }} />
						</div>
					</div>)}
				</div>
				<FooterInquiryForm />
			</div>
		)}
	/>);
};

export default About;
